module.exports = __webpack_public_path__ + "static/media/masjid_ummu_kulthum_hilal4.89598955.webp";